export type AtVirtualClinicSaps3Zutransferierung =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7';

export const AT_VIRTUAL_CLINIC_SAPS3_ZUTRANSFERIERUNG_DISPLAY_NAMES: {
  [status in AtVirtualClinicSaps3Zutransferierung]: string;
} = {
  '1': 'Bettenstation',
  '2': 'Notaufnahme',
  '3': 'Andere Intensivstation',
  '4': 'IMCU',
  '5': 'OP',
  '6': 'Aufwachraum',
  '7': 'Andere',
};
